import { TREE_WIDGETS, TreeWidgetType, WidgetType } from "../models/widgetType"

export const isTreeWidgetType = (type: WidgetType): type is TreeWidgetType => {
  return type in TREE_WIDGETS
}
